export default __webpack_public_path__ + "static/media/army_91.5b82e67a.jpg";